import { render, staticRenderFns } from "./AddOutboundRuleset.vue?vue&type=template&id=048ff7eb"
import script from "./AddOutboundRuleset.vue?vue&type=script&lang=js"
export * from "./AddOutboundRuleset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports